import {PipelineGraphQL} from 'pipelines/PipelineTypes';
/**
 * Return whether the analysis is read-only.
 *
 * This returns true for read-only analyses, including archived analyses that the user may not unarchive,
 * for which options to modify the analysis should be hidden, since the user could not enable those options.
 *
 * This returns false for archived analyses that the user may unarchive, for which options to modify the
 * analysis should be visible but disabled, since the user could re-enable those options.
 */
export default function isAnalysisReadOnly({
  permissions,
  archiveRecord,
}: Pick<PipelineGraphQL, 'permissions' | 'archiveRecord'>): boolean {
  return !permissions.writable && !(archiveRecord != null && permissions.unarchivable);
}
